import { render, staticRenderFns } from "./loadAudience.vue?vue&type=template&id=760ba6d5&lang=pug"
import script from "./loadAudience.vue?vue&type=script&lang=js"
export * from "./loadAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports